import { IonButtons, IonHeader, IonToolbar } from '@ionic/react';
import { ReactElement, forwardRef } from 'react';
import { CustomBackButton } from '../../components/header/back-button';
import {
  HeaderProps,
  pageTitleBuilder,
} from '../../components/header/page.header';

export interface DirectConnectPageHeaderProps
  extends Omit<HeaderProps, 'bookmarkProps'> {
  defaultBackRoute?: string;
}

const DirectConnectPageHeader = forwardRef<
  HTMLIonHeaderElement,
  DirectConnectPageHeaderProps
>((props: DirectConnectPageHeaderProps, ref): ReactElement => {
  const {
    children,
    title,
    subtitle,
    secondaryToolbar,
    rightButtons,
    defaultBackRoute,
  } = props;

  return (
    <IonHeader ref={ref} className="primary-header">
      <IonToolbar className="primary-toolbar">
        <IonButtons slot="start">
          {defaultBackRoute && (
            <CustomBackButton defaultHref={props.defaultBackRoute} />
          )}
        </IonButtons>
        {children ? children : pageTitleBuilder(title, subtitle)}
        <IonButtons slot="end">{rightButtons}</IonButtons>
      </IonToolbar>
      {secondaryToolbar && (
        <IonToolbar className="secondary-toolbar">
          {secondaryToolbar}
        </IonToolbar>
      )}
    </IonHeader>
  );
});

DirectConnectPageHeader.displayName = 'DirectConnectPageHeader';

export { DirectConnectPageHeader };
